import { call, fork, put, take } from 'redux-saga/effects'
import { bindAsyncAction } from 'typescript-fsa-redux-saga'
import { Action } from 'typescript-fsa'
import {
  AutorisationROApi,
  FacebookConnectApi,
  InstagramConnectApi,
  SmPublishConnectApi,
  SmPublishAuthApi,
  SocialmediaUserApi,
  SocialmediaEditorApi,
  ImprintAPI, UserHasPageApi,
  UserSearchApi,
  AnnouncementApi,
} from '../../api/instances'
import {
  getCurrentUser,
  getCurrentUserInitiated,
  getFacebookConnectData,
  getFacebookConnectDataInitiated,
  getInstagramConnectData,
  getInstagramConnectDataInitiated,
  getSmPublishAuthToken,
  getSmPublishAuthTokenInitiated,
  initiateFacebookConnect,
  initiateFacebookConnectInitiated,
  initiateGoogleConnect,
  initiateGoogleConnectInitiated,
  initiateInstagramConnect,
  initiateInstagramConnectInitiated,
  logout,
  logoutInitiated,
  performConnect,
  performConnectInitiated,
  performDisconnect,
  performDisconnectInitiated,
  socialmediaUserConnect,
  socialmediaUserConnectInitiated,
  socialmediaUserDisconnect,
  socialmediaUserDisconnectInitiated,
  socialmediaEditorConnect,
  socialmediaEditorConnectInitiated,
  socialmediaEditorDisconnect,
  socialmediaEditorDisconnectInitiated,
  updateUserAccount,
  updateUserAccountInitiated,
  requestStarted,
  requestFinished,
  requestFailed,
  getPotentialPageImprint,
  getPotentialPageImprintInitiated,
  setOrUpdateImprintInitiated,
  setOrUpdateImprint,
  userLogin,
  userLoginInitiated,
  getPageIdentifierForCurrentUserInitiated,
  getPageIdentifierForCurrentUser,
  getPageIdentifiersForUserInitiated,
  getPageIdentifiersForUser,
  getUserByPnrInitiated,
  getUserByPnr,
  addUserPageRelationByAgencyNumberInitiated,
  addUserPageRelationByAgencyNumber,
  getActiveAnnouncement,
  getActiveAnnouncementInitiated,
  updateAnnouncement,
  updateAnnouncementInitiated,
  acceptAnnouncement,
  acceptAnnouncementInitiated,
} from './common.actions'

import {
  InitiateConnectOperationRequest, PerformConnectOperationRequest, PerformDisconnectRequest,
} from '@professocialApi/professocial-core-frontend-api/apis/SmPublishConnectApi'
import { GetFacebookConnectDataRequest, GetInstagramConnectDataRequest } from '@3m5/sm_publish-frontend-api'
import {
  SocialmediaUserConnectRequest,
  SocialmediaUserDisconnectRequest,
} from '@professocialApi/professocial-core-frontend-api/apis/SocialmediaUserApi'
import {
  SocialmediaEditorConnectRequest,
  SocialmediaEditorDisconnectRequest,
} from '@professocialApi/professocial-core-frontend-api/apis/SocialmediaEditorApi'
import { UpdateUserAccountRequest } from '@professocialApi/professocial-core-frontend-api/apis/UserLoginRESTServiceApi'
import { UserLoginRESTServiceApi } from '@professocial/professocialAccounts/src/api/instances'
import { SetOrUpdateImprintRequest } from '@professocialApi/professocial-core-frontend-api/apis/ImprintApi'
import { GetPageIdentifiersForUserRequest, PageIdentifier, UserLoginRequest } from '@professocialApi/professocial-core-frontend-api'
import {
  AddUserPageRelationByAgencyNumberRequest,
  FindByPnrRequest
} from '@professocialApi/professocial-core-frontend-api/apis/UserSearchApi'
import { EventType, Severity } from '@professocial/professocialTypes/types'
import i18n from 'i18next'
import { UpdateCurrentAnnouncementRequest } from '@professocialApi/professocial-core-frontend-api/apis/AnnouncementApi'


// logout
const logoutWorker = bindAsyncAction(logout)(
  function* () {
    return yield call([AutorisationROApi, AutorisationROApi.userLogout])
  },
)

function* watchLogoutInitiated() {
  while (true) {
    const action: Action<undefined> = yield take(logoutInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield logoutWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(requestFailed({ type: action.type, error: e }))
      console.error('error in watchLogoutInitiated: ', e)
    }
  }
}

// getCurrentUser
const getUserAccountWorker = bindAsyncAction(getCurrentUser)(
  function* () {
    return yield call([AutorisationROApi, AutorisationROApi.getCurrentUser])
  },
)

function* watchGetUserAccountInitiated() {
  while (true) {
    const action: Action<undefined> = yield take(getCurrentUserInitiated)
    try {
      yield getUserAccountWorker(action.payload)
    } catch (e) {
      console.error('error in watchGetUserAccountInitiated: ', e)
    }
  }
}

// initiateFacebookConnect
const initiateFacebookConnectWorker = bindAsyncAction(initiateFacebookConnect)(
  function* (params: InitiateConnectOperationRequest) {
    return yield call([SmPublishConnectApi, SmPublishConnectApi.initiateConnect], params)
  },
)

function* watchInitiateFacebookConnectInitiated() {
  while (true) {
    const action: Action<InitiateConnectOperationRequest> = yield take(initiateFacebookConnectInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield initiateFacebookConnectWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(requestFailed({ type: action.type, error: e }))
      console.error('error in watchInitiateFacebookConnectInitiated: ', e)
    }
  }
}

// initiateInstagramConnect
const initiateInstagramConnectWorker = bindAsyncAction(initiateInstagramConnect)(
  function* (params: InitiateConnectOperationRequest) {
    return yield call([SmPublishConnectApi, SmPublishConnectApi.initiateConnect], params)
  },
)

function* watchInitiateInstagramConnectInitiated() {
  while (true) {
    const action: Action<InitiateConnectOperationRequest> = yield take(initiateInstagramConnectInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield initiateInstagramConnectWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(requestFailed({ type: action.type, error: e }))
      console.error('error in watchInitiateInstagramConnectInitiated: ', e)
    }
  }
}


const initiateGetPageIdentifierWorker = bindAsyncAction(getPageIdentifierForCurrentUser)(
  function* (params: void) {
    const result: PageIdentifier[] = yield call([UserHasPageApi, UserHasPageApi.getPageIdentifiersForCurrentUser])
    yield put(getPageIdentifierForCurrentUser.done({ result }))
  }
)

function* watchGetPageIdentifierForCurrentUserInitiated() {
  while (true) {
    const action: Action<void> = yield take(getPageIdentifierForCurrentUserInitiated)
    {
      try {
        yield initiateGetPageIdentifierWorker(action.payload)
      } catch (e) {
        console.error('error in watchGetPageIdentifierForCurrentUserInitiated: ', e)
      }
    }
  }
}



// initiateGoogleConnect
const initiateGoogleConnectWorker = bindAsyncAction(initiateGoogleConnect)(
  function* (params: InitiateConnectOperationRequest) {
    return yield call([SmPublishConnectApi, SmPublishConnectApi.initiateConnect], params)
  },
)

function* watchInitiateGoogleConnectInitiated() {
  while (true) {
    const action: Action<InitiateConnectOperationRequest> = yield take(initiateGoogleConnectInitiated)
    try {
      yield initiateGoogleConnectWorker(action.payload)
    } catch (e) {
      console.error('error in watchInitiateInstagramConnectInitiated: ', e)
    }
  }
}

// getFacebookConnectData
const getFacebookConnectDataWorker = bindAsyncAction(getFacebookConnectData)(
  function* (params: GetFacebookConnectDataRequest) {
    return yield call([FacebookConnectApi, FacebookConnectApi.getFacebookConnectData], params)
  },
)

function* watchGetFacebookConnectDataInitiated() {
  while (true) {
    const action: Action<GetFacebookConnectDataRequest> = yield take(getFacebookConnectDataInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield getFacebookConnectDataWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(requestFailed({ type: action.type, error: e }))
      console.error('error in watchGetFacebookConnectDataInitiated: ', e)
    }
  }
}

// getInstagramConnectData
const getInstagramConnectDataWorker = bindAsyncAction(getInstagramConnectData)(
  function* (params: GetInstagramConnectDataRequest) {
    return yield call([InstagramConnectApi, InstagramConnectApi.getInstagramConnectData], params)
  },
)

function* watchGetInstagramConnectDataInitiated() {
  while (true) {
    const action: Action<GetInstagramConnectDataRequest> = yield take(getInstagramConnectDataInitiated)
    try {
      yield getInstagramConnectDataWorker(action.payload)
    } catch (e) {
      console.error('error in watchGetInstagramConnectDataInitiated: ', e)
    }
  }
}

// performConnect
const performConnectWorker = bindAsyncAction(performConnect)(
  function* (params: PerformConnectOperationRequest) {
    return yield call([SmPublishConnectApi, SmPublishConnectApi.performConnect], params)
  },
)

function* watchPerformConnectInitiated() {
  while (true) {
    const action: Action<PerformConnectOperationRequest> = yield take(performConnectInitiated)
    try {
      yield performConnectWorker(action.payload)
    } catch (e) {
      console.error('error in watchPerformConnectInitiated: ', e)
    }
  }
}

// performDisconnect
const performDisconnectWorker = bindAsyncAction(performDisconnect)(
  function* (params: PerformDisconnectRequest) {
    return yield call([SmPublishConnectApi, SmPublishConnectApi.performDisconnect], params)
  },
)

function* watchPerformDisconnectInitiated() {
  while (true) {
    const action: Action<PerformDisconnectRequest> = yield take(performDisconnectInitiated)
    try {
      yield performDisconnectWorker(action.payload)
    } catch (e) {
      console.error('error in watchPerformDisconnectInitiated: ', e)
    }
  }
}

// getSmPublishAuthToken
const getSmPublishAuthTokenWorker = bindAsyncAction(getSmPublishAuthToken)(
  function* () {
    return yield call([SmPublishAuthApi, SmPublishAuthApi.getSmPublishAuthToken])
  },
)

function* watchGetSmPublishAuthTokenInitiated() {
  while (true) {
    const action: Action<undefined> = yield take(getSmPublishAuthTokenInitiated)
    try {
      yield getSmPublishAuthTokenWorker(action.payload)
    } catch (e) {
      console.error('error in watchGetSmPublishAuthTokenInitiated: ', e)
    }
  }
}

// socialmediaUserConnect
const socialmediaUserConnectWorker = bindAsyncAction(socialmediaUserConnect)(
  function* (params: SocialmediaUserConnectRequest) {
    return yield call([SocialmediaUserApi, SocialmediaUserApi.socialmediaUserConnect], params)
  },
)

function* watchSocialmediaUserConnectInitiated() {
  while (true) {
    const action: Action<SocialmediaUserConnectRequest> = yield take(socialmediaUserConnectInitiated)
    try {
      yield socialmediaUserConnectWorker(action.payload)
    } catch (e) {
      console.error('error in watchSocialmediaUserConnectInitiated: ', e)
    }
  }
}

// socialmediaUserDisconnect
const socialmediaUserDisconnectWorker = bindAsyncAction(socialmediaUserDisconnect)(
  function* (params: SocialmediaUserDisconnectRequest) {
    return yield call([SocialmediaUserApi, SocialmediaUserApi.socialmediaUserDisconnect], params)
  },
)

function* watchSocialmediaUserDisconnectInitiated() {
  while (true) {
    const action: Action<SocialmediaUserDisconnectRequest> = yield take(socialmediaUserDisconnectInitiated)
    try {
      yield socialmediaUserDisconnectWorker(action.payload)
    } catch (e) {
      console.error('error in watchSocialmediaUserDisconnectInitiated: ', e)
    }
  }
}

// socialmediaEditorConnect
const socialmediaEditorConnectWorker = bindAsyncAction(socialmediaEditorConnect)(
  function* (params: SocialmediaEditorConnectRequest) {
    return yield call([SocialmediaEditorApi, SocialmediaEditorApi.socialmediaEditorConnect], params)
  },
)

function* watchSocialmediaEditorConnectInitiated() {
  while (true) {
    const action: Action<SocialmediaEditorConnectRequest> = yield take(socialmediaEditorConnectInitiated)
    try {
      yield socialmediaEditorConnectWorker(action.payload)
    } catch (e) {
      console.error('error in watchSocialmediaEditorConnectInitiated: ', e)
    }
  }
}

// socialmediaEditorDisconnect
const socialmediaEditorDisconnectWorker = bindAsyncAction(socialmediaEditorDisconnect)(
  function* (params: SocialmediaEditorDisconnectRequest) {
    return yield call([SocialmediaEditorApi, SocialmediaEditorApi.socialmediaEditorDisconnect], params)
  },
)

function* watchSocialmediaEditorDisconnectInitiated() {
  while (true) {
    const action: Action<SocialmediaEditorDisconnectRequest> = yield take(socialmediaEditorDisconnectInitiated)
    try {
      yield socialmediaEditorDisconnectWorker(action.payload)
    } catch (e) {
      console.error('error in watchSocialmediaEditorDisconnectInitiated: ', e)
    }
  }
}

// updateUserAccount
const updateUserAccountWorker = bindAsyncAction(updateUserAccount)(
  function* (params: UpdateUserAccountRequest) {
    return yield call([UserLoginRESTServiceApi, UserLoginRESTServiceApi.updateUserAccount], params)
  },
)

function* watchUpdateUserAccountInitiated() {
  while (true) {
    const action: Action<UpdateUserAccountRequest> = yield take(updateUserAccountInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield updateUserAccountWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(requestFailed({ type: action.type, error: e }))
      console.error('error in watchUpdateUserAccountInitiated: ', e)
    }
  }
}

const getUserByPnrWorker = bindAsyncAction(getUserByPnr)(
  function* (params: FindByPnrRequest) {
    return yield call([UserSearchApi, UserSearchApi.findByPnr], params)
  },
)

function* watchGetUserByPnrInitiated() {
  while (true) {
    const action: Action<FindByPnrRequest> = yield take(getUserByPnrInitiated)
    try {
      console.log('watchGetUserByPnrInitiated executed')
      yield getUserByPnrWorker(action.payload)
      yield put(requestFinished({
        type: action.type,
        message: {
          severity: Severity.success,
          message: i18n.t('accountsCommon:pnrUserSuccess'),
          eventType: EventType.load,
        },
      }))
    } catch (e) {
      handleGetUserByPnrError(e)
      yield put(requestFailed({
        type: action.type,
        error: e,
        message: {
          severity: Severity.error,
          message: i18n.t('accountsCommon:pnrUserFailed'),
          eventType: EventType.load,
        },
      }))
      console.error('error in watchGetUserByPnrInitiated: ', e)
    }
  }
}

const addUserPageRelationByAgencyNumberWorker = bindAsyncAction(addUserPageRelationByAgencyNumber)(
  function* (params: AddUserPageRelationByAgencyNumberRequest) {
    return yield call([UserSearchApi, UserSearchApi.addUserPageRelationByAgencyNumber], params)
  },
)

function* watchAddUserPageRelationByAgencyNumberInitiated() {
  while (true) {
    const action: Action<AddUserPageRelationByAgencyNumberRequest> = yield take(addUserPageRelationByAgencyNumberInitiated)
    try {
      yield addUserPageRelationByAgencyNumberWorker(action.payload)
      yield put(requestFinished({
        type: action.type,
        message: {
          severity: Severity.success,
          message: i18n.t('accountsCommon:pnrUserAddedSuccess'),
          eventType: EventType.create,
        },
      }))
    } catch (e) {
      console.error('error in : watchAddUserPageRelationByAgencyNumberInitiated', e)
      yield put(requestFinished({
        type: action.type,
        message: {
          severity: Severity.success,
          message: i18n.t('accountsCommon:pnrUserAddedFailed'),
          eventType: EventType.create,
        },
      }))
    }
  }
}

// getPotentialPageImprint
const getPotentialPageImprintWorker = bindAsyncAction(getPotentialPageImprint)(
  function* () {
    return yield call([ImprintAPI, ImprintAPI.getPotentialPageImprint])
  },
)

function* watchGetPotentialPageImprintInitiated() {
  while (true) {
    const action: Action<undefined> = yield take(getPotentialPageImprintInitiated)
    try {
      yield getPotentialPageImprintWorker(action.payload)
    } catch (e) {
      console.error('error in watchGetPotentialPageImprintInitiated: ', e)
    }
  }
}

// setOrUpdateImprint
const setOrUpdateImprintWorker = bindAsyncAction(setOrUpdateImprint)(
  function* (params: SetOrUpdateImprintRequest) {
    return yield call([ImprintAPI, ImprintAPI.setOrUpdateImprint], params)
  },
)

function* watchSetOrUpdateImprintInitiated() {
  while (true) {
    const action: Action<SetOrUpdateImprintRequest> = yield take(setOrUpdateImprintInitiated)
    try {
      yield setOrUpdateImprintWorker(action.payload)
    } catch (e) {
      console.error('error in watchSetOrUpdateImprintInitiated: ', e)
    }
  }
}

// login
const userLoginWorker = bindAsyncAction(userLogin)(
  function* (params: UserLoginRequest) {
    return yield call([AutorisationROApi, AutorisationROApi.userLogin], params)
  },
)

function* watchUserLoginInitiated() {
  while (true) {
    const action: Action<UserLoginRequest> = yield take(userLoginInitiated)
    yield put(requestStarted({ type: action.type }))
    try {
      yield userLoginWorker(action.payload)
      yield put(requestFinished({ type: action.type }))
    } catch (e) {
      yield put(requestFailed({ type: action.type, error: e }))
    }
  }
}

// getPageIdentifiersForUser
const getPageIdentifiersForUserWorker = bindAsyncAction(getPageIdentifiersForUser)(
  function* (params: GetPageIdentifiersForUserRequest) {
    return yield call([UserHasPageApi, UserHasPageApi.getPageIdentifiersForUser], params)
  },
)

function* watchGetPageIdentifiersForUserInitiated() {
  while (true) {
    const action: Action<GetPageIdentifiersForUserRequest> = yield take(getPageIdentifiersForUserInitiated)
    try {
      yield getPageIdentifiersForUserWorker(action.payload)
    } catch (e) {
      console.error('error in watchGetPageIdentifiersForUserInitiated: ', e)
    }
  }
}

// === Announcements ===

const getActiveAnnouncementForUserWorker = bindAsyncAction(getActiveAnnouncement)(
  function* () {
    return yield call([AnnouncementApi, AnnouncementApi.getCurrentActiveAnnouncement])
  },
)

function* watchGetActiveAnnouncementForUserWorkerInitiated() {
  while (true) {
    const action: Action<undefined> = yield take(getActiveAnnouncementInitiated)
    try {
      yield getActiveAnnouncementForUserWorker(action.payload)
    } catch (e) {
      console.error('error in getActiveAnnouncementInitiated: ', e)
    }
  }
}

// --- acceptAnnouncement ---
const acceptAnnouncementWorker = bindAsyncAction(acceptAnnouncement)(
  function* () {
    return yield call([AnnouncementApi, AnnouncementApi.acceptAnnouncement])
  }
)

function* watchAcceptAnnouncementInitiated() {
  while (true) {
    const action: Action<undefined> = yield take(acceptAnnouncementInitiated)
    try {
      yield acceptAnnouncementWorker(action.payload)
    } catch (e) {
      console.error('error in watchAcceptAnnouncementInitiated: ', e)
    }
  }
}

// --- updateAnnouncementTemplate ---
const updateAnnouncementTemplateWorker = bindAsyncAction(updateAnnouncement)(
  function* (params: UpdateCurrentAnnouncementRequest) {
    return yield call([AnnouncementApi, AnnouncementApi.updateCurrentAnnouncement], params)
  }
)

function* watchUpdateAnnouncementTemplateInitiated() {
  while (true) {
    const action: Action<UpdateCurrentAnnouncementRequest> = yield take(updateAnnouncementInitiated)
    try {
      yield updateAnnouncementTemplateWorker(action.payload)
      yield put(requestFinished({
        type: action.type,
        message: {
          severity: Severity.success,
          message: i18n.t('announcement:updateAnnouncementSuccess'),
          eventType: EventType.update,
        },
      }))
    } catch (e) {
      console.error('error in watchUpdateAnnouncementTemplateInitiated: ', e)
      yield put(requestFinished({
        type: action.type,
        message: {
          severity: Severity.error,
          message: i18n.t('announcement:updateAnnouncementFailed'),
          eventType: EventType.update,
        },
      }))
    }
  }
}

// --- ERROR HANDLING HELPER ---
function handleGetUserByPnrError(e: any) {
  const response = e?.response

  // If the backend returns a 404 => no user found
  if (response?.status === 404) {
    console.warn('No user found (404).', e)
  }
  // If the backend returns a 500 => check specific error codes
  else if (response?.status === 500) {
    const errorCode = response?.data?.errorCode

    if (errorCode === 60001) {
      console.warn('Received error code 60001 from backend.', e)
    }
  }
}

export function* commonSagas() {
  yield fork(watchLogoutInitiated)
  yield fork(watchGetUserAccountInitiated)
  yield fork(watchGetPageIdentifierForCurrentUserInitiated)
  yield fork(watchInitiateFacebookConnectInitiated)
  yield fork(watchInitiateInstagramConnectInitiated)
  yield fork(watchInitiateGoogleConnectInitiated)
  yield fork(watchGetFacebookConnectDataInitiated)
  yield fork(watchGetInstagramConnectDataInitiated)
  yield fork(watchPerformConnectInitiated)
  yield fork(watchPerformDisconnectInitiated)
  yield fork(watchGetSmPublishAuthTokenInitiated)
  yield fork(watchSocialmediaUserConnectInitiated)
  yield fork(watchSocialmediaUserDisconnectInitiated)
  yield fork(watchSocialmediaEditorConnectInitiated)
  yield fork(watchSocialmediaEditorDisconnectInitiated)
  yield fork(watchUpdateUserAccountInitiated)
  yield fork(watchGetPotentialPageImprintInitiated)
  yield fork(watchSetOrUpdateImprintInitiated)
  yield fork(watchUserLoginInitiated)
  yield fork(watchGetPageIdentifiersForUserInitiated)
  yield fork(watchGetUserByPnrInitiated)
  yield fork(watchAddUserPageRelationByAgencyNumberInitiated)
  yield fork(watchGetActiveAnnouncementForUserWorkerInitiated)
  yield fork(watchGetActiveAnnouncementForUserWorkerInitiated)
  yield fork(watchAcceptAnnouncementInitiated)
  yield fork(watchUpdateAnnouncementTemplateInitiated)
}
